import "@/App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ScrollToTop from "@/components/ScrollToTop";
import { initConsent } from "@/lib/consent";

// Legal pages are split into separate bundles, loaded on demand only when
// the user navigates to /impressum, /datenschutz or /agb.  Keeps the
// initial landing-page bundle small.
const Impressum = lazy(() => import("@/pages/Impressum"));
const Datenschutz = lazy(() => import("@/pages/Datenschutz"));
const AGB = lazy(() => import("@/pages/AGB"));
const Barrierefreiheit = lazy(() => import("@/pages/Barrierefreiheit"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center text-bone/40 text-sm">
    Lädt…
  </div>
);

function App() {
  // Re-load Google Ads (gtag) on subsequent visits if the user previously
  // consented to marketing cookies. Runs on ALL routes (not just Home).
  useEffect(() => {
    initConsent();
  }, []);

  return (
    <div className="App font-body bg-ink text-bone grain min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/barrierefreiheit" element={<Barrierefreiheit />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
